exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content .modal-footer .footer-block{text-align:center}", ""]);

// exports
